import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCrmProject } from ".";
import { queryKeys } from "../../../../../lib/useQuery/queryKeys";

export function useDeleteCrmProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: queryKeys.crm_project._def,
    mutationFn: deleteCrmProject,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.crm_project._def,
        exact: false,
      });
    },
  });
}
